import { render, staticRenderFns } from "./RegistrationNotePopup.vue?vue&type=template&id=16571de8&scoped=true&"
import script from "./RegistrationNotePopup.vue?vue&type=script&lang=js&"
export * from "./RegistrationNotePopup.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationNotePopup.vue?vue&type=style&index=0&id=16571de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16571de8",
  null
  
)

export default component.exports